/* @flow */
export const CONSENT_CHARGE_AMOUNT = '$0.50';



// WEBPACK FOOTER //
// ./src/constants/ParentalConsentConstants.js